import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteDataProvider } from "./context/SiteDataContext";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import ScrollToTop from "./components/layout/ScrollToTop";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import "./styles/global.css";

function App() {
  return (
    <SiteDataProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hizmetler" element={<Services />} />
            <Route path="/portfoy" element={<Portfolio />} />
            <Route path="/hakkimda" element={<About />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </SiteDataProvider>
  );
}

export default App;
